module.exports = __webpack_public_path__ + "img/warmup_hair.f7c9ab18.jpg";